import React, { useEffect } from "react";
import { useField } from "react-final-form";
import {
  AutocompleteInput,
  ReferenceInput,
  required,
  useDataProvider,
} from "react-admin";
import { SchoolIdSelected } from "utils/tools";

interface ICustomWaveInput {
  isDisable?: boolean;
  isEdit?: boolean;
  isRequired?: boolean;
}

const CustomWaveInput = ({
  isEdit,
  isDisable,
  isRequired,
}: ICustomWaveInput) => {
  const busSchedulePlanInput = useField("busSchedulePlanId");
  const waveInput = useField("busScheduleId");

  const provider = useDataProvider();

  const schoolId = Number(SchoolIdSelected());

  useEffect(() => {
    if (schoolId && !isEdit) {
      waveInput.input.onChange("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId]);

  useEffect(() => {
    const isBusSchedulePlanIdNotZero =
      Number(busSchedulePlanInput.input.value) !== 0;

    if (isEdit && isBusSchedulePlanIdNotZero) {
      provider
        .getOne("busSchedulePlans", {
          id: Number(busSchedulePlanInput.input.value),
        })
        .then(({ data }) => {
          waveInput.input.onChange(data.busScheduleId);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busSchedulePlanInput.input.value]);

  return (
    <>
      {!isEdit ? (
        <ReferenceInput
          label="Select Wave"
          source="busScheduleId"
          reference="busSchedules"
          filter={{ SchoolId: schoolId, HasRoutePlan: true }}
          disabled={isDisable}
          validate={isRequired ? required() : undefined}
          perPage={25}
          filterToQuery={(searchText: any) => {
            if (searchText !== "") return { search: searchText };
          }}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
      ) : (
        <ReferenceInput
          label="Select Wave"
          source="busScheduleId"
          reference="busSchedules"
          disabled={isDisable}
          validate={isRequired ? required() : undefined}
          perPage={25}
          filterToQuery={(searchText: any) => {
            if (searchText !== "") return { search: searchText };
          }}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
      )}
    </>
  );
};

export default CustomWaveInput;
